import React from 'react';
import PropTypes from 'prop-types';
import {adminUiTexts, loginUiTexts} from 'data/ui-texts';
import Button from 'components/ui/button/button';
import './admin.scss';


const Admin = ({handleLogout}) => {

	return (
		<div className="Admin">
			<div className="Admin-title">
				<span>{adminUiTexts.admin}</span>
			</div>
			
			{/* Logout button */}
			<div className="Admin-logoutBtn">
				<Button 
					classes={['login', 'logout']} 
					text={loginUiTexts.logout}
					onClick={() => {handleLogout();}}
				/>
			</div>
		</div>
	);
};

Admin.propTypes = {
	handleLogout: PropTypes.func.isRequired,
};

export default Admin;
